import { ErrorCode } from 'src/constants';
import { Maybe } from 'src/utils';

export class BaseError extends Error {
  private _name: string;
  private _code: Maybe<ErrorCode>;

  constructor(message: string, { code, name }: { code?: ErrorCode; name: string }) {
    super(message);
    this._code = code;
    this._name = name;
  }

  get code(): Maybe<ErrorCode> {
    return this._code;
  }

  get name(): string {
    return this._name;
  }
}
